<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
// /admin/system-setting/mail-address-setting
export default {
  name: 'app',
}
</script>

<style>
#app {
  width: 100%;
  height: 100%;
  overflow: hidden;
  font-family: Microsoft Yahei, '微软雅黑', Arial, Helvetica, 'Avenir', Arial,
    sans-serif;
}
</style>
